import React from 'react';
import PropTypes from 'prop-types';
import { DragSource as dragSource } from 'react-dnd';
import style from './DraggablePlaceholder.scss';

const source = {
  beginDrag: (props) => {
    props.componentStartDragging();
    return props.data;
  },
  endDrag: (props) => {
    props.componentStopDragging();
    return props.data;
  },
};

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging(),
  };
}

class DraggablePlaceholder extends React.Component {
  static propTypes = {
    type: PropTypes.any.isRequired,
    data: PropTypes.any.isRequired,
    name: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    connectDragSource: PropTypes.func.isRequired,
    connectDragPreview: PropTypes.func.isRequired,
    isDragging: PropTypes.bool.isRequired,
  };

  render() {
    const { connectDragSource, isDragging, name } = this.props;

    const classes = [style.root];
    if (isDragging) {
      classes.push(style.dragging);
    }

    return connectDragSource(
      <div className={classes.join(' ')}>
        {name}
      </div>,
    );
  }
}

export default dragSource(props => props.type, source, collect)(DraggablePlaceholder);
